/**
 * @file: serviceSubjectItemToSubject.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ServiceSubject } from '@euler/model';
import { ServiceSubjectType } from '@euler/model/enum';
import { ServiceSubjectItem } from '../types';

export function serviceSubjectItemToSubject(
  item: ServiceSubjectItem,
  assignedTo?: { id: number; name: string },
): ServiceSubject {
  switch (item.type) {
    case ServiceSubjectType.Inspection: {
      if (assignedTo == null) {
        throw new Error('assignTo is required');
      }
      return {
        type: ServiceSubjectType.Inspection,
        name: item.title,
        templateId: item.template.cid,
        assignedTo,
      };
    }
    case ServiceSubjectType.Fault: {
      return {
        type: ServiceSubjectType.Fault,
        name: item.title,
        assignedTo,
        note: item.note,
      };
    }
    case ServiceSubjectType.Construction: {
      return {
        type: ServiceSubjectType.Construction,
        name: item.title,
        procedures: item.template?.procedures.map(x => ({
          name: x.name,
          type: x.type,
        })),
        pendingIssueId: item.pendingIssue?.issue.issueId,
        assignedTo,
      };
    }
    case ServiceSubjectType.Other: {
      return {
        type: ServiceSubjectType.Other,
        name: item.title,
        note: item.note,
      };
    }
  }
}
